<template>
  <div
    class="min-w-full absolute pin"
    :style="{
      transform: `translateX(${translateX}px)`,
      transition: `transform ${transitionDuration}s`,
    }"
  >
    <slot />
  </div>
</template>


<script>
export default {
  name: 'UICarouselItem',
  data: () => ({
    translateX: 0,
    transitionDuration: 0,
  }),
  mounted() {
    this.$parent.updateItems();
  },
  methods: {
    translateItem(index, activeIndex) {
      const parentWidth = this.$parent.$el.offsetWidth;
      this.translateX = parentWidth * (index - activeIndex);
    },
    setTransformTransitionDuration(duration) {
      this.transitionDuration = duration;
    },
  },
};
</script>
